export enum DocReadEnum {
    ALL_READ = 'all_read',
    PARTIAL_READ = 'partial_read'
}



// WEBPACK FOOTER //
// ./src/app/enum/doc-read.enum.ts